<template>
    <div class="warning" v-html="message"></div>
</template>

<script>
    export default {
        name: "Warning",
        props: ["message"]
    }
</script>

<style scoped lang="scss">
    .warning {
        margin-bottom: 20px;
        padding: 16px;
        font-size: 14px;
        line-height: 20px;

        color: #A26922;
        border: 1px solid #EBB97A;
        border-radius: 3px;
        background: #FEDAA4;
    }
</style>